import 'jquery';

/**
 * toggles disabled state on submit buttons
 * adds class filled to each filled input
 *
 */
(function ($, document) {

  var toggleSubmit = function (form) {
    let btn = form.find('.btn[type=submit]');

    if (form.get(0).checkValidity() === true) {
      btn.prop('disabled', false);
      // form.find('.error-message').hide();
      // form.find('.error-message').hide();
    } else {
      btn.prop('disabled', true);
      // form.find('.error-message').show();
    }
  };

  $(document).on('keyup change', '.form-control, .form-check-input', function () {
    let input = $(this);
    let form = input.closest('form');

    if (input.val() === '') {
      input.removeClass('filled');
    } else {
      input.addClass('filled');
    }

    toggleSubmit(form);
  });

  $('form').each(function () {
    toggleSubmit($(this));
  });

}(jQuery, document));
